import React from "react";
import mergeClasses from "@/utils/merge-classes.ts";

interface CheckBoxProps extends React.InputHTMLAttributes<HTMLInputElement> {
    checkedColors?: string;
}

const CheckBox: React.FC<CheckBoxProps> = ({className, checkedColors = 'checked:border-blue-300 checked:bg-blue-300', ...props}) => (
    <input
        type="checkbox"
        className={mergeClasses(`appearance-none rounded-sm border ${checkedColors} border-gray-300 bg-white disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100`, className)}
        {...props}
    />
)

export default CheckBox;